// import {combineReducers} from "redux";
import Spot from './SpotReducer';

// if there are more than one reducer in this component, use combineReducers
/*
const Spot = combineReducers({
    Spot
})
*/

export default Spot;
